import React, { useCallback } from 'react';
import { DataGrid, GridColDef } from '@material-ui/data-grid';
import { Tooltip } from '@material-ui/core';
import { ContainerAcoes, ContainerGrid } from '../styles';
import { GoPencil } from 'react-icons/go';
import { useProduto } from '~/pages/Produto/hooks/useProduto';
import { IProdutoDerivado } from '~/pages/Produto/types';
import { MdDeleteForever } from 'react-icons/md';
import { deleteItens } from '~/utils/masterDetail';

export const TableDerivados: React.FC = () => {
  const {
    resetDerivado,
    handleIsEditingDerivado,
    handleOpenModalDerivado,
    rowsDerivado,
    loadingTableDerivado,
    masterDetail,
    setMasterDetail,
    setRowsDerivado,
  } = useProduto();

  const columnsDerivados: GridColDef[] = [
    {
      field: 'cod_produto_derivado',
      headerName: 'PLU',
      width: 160,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: 'des_produto',
      headerName: 'Descrição',
      width: 700,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params: any) => {
        const { row } = params;
        return (
          <Tooltip title={row.des_produto}>
            <span>{row.des_produto}</span>
          </Tooltip>
        );
      },
    },
    {
      field: 'cod_departamento',
      headerName: 'Departamento',
      disableColumnMenu: true,
      hide: true,
    },
    {
      field: 'cod_tipo_ajuste',
      headerName: 'Ajuste',
      width: 300,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params: any) => {
        const { row } = params;
        return (
          <Tooltip title={row.cod_tipo_ajuste.label}>
            <span>{row.cod_tipo_ajuste.label}</span>
          </Tooltip>
        );
      },
    },
    {
      field: 'acao',
      headerName: 'Ações',
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 100,
      disableColumnMenu: true,
      sortable: false,
      headerClassName: 'hideRightSeparator',
      renderCell: (params: any) => {
        const { row } = params;
        return (
          <ContainerAcoes>
            <button
              type="button"
              onClick={() => {
                handleEdit(row);
              }}
            >
              <GoPencil size={20} style={{ color: '#72ab90' }} />
            </button>
            <button
              type="button"
              onClick={() => {
                handleDelete(row);
              }}
            >
              <MdDeleteForever size={20} style={{ color: '#e63c3c' }} />
            </button>
          </ContainerAcoes>
        );
      },
    },
  ];

  const handleEdit = useCallback(
    (row: IProdutoDerivado) => {
      resetDerivado({
        des_produto: row.des_produto,
        cod_departamento: row.cod_departamento,
        cod_tipo_ajuste: {
          label: row.cod_tipo_ajuste.label,
          value: row.cod_tipo_ajuste.value,
        },
        des_unidade: {
          label: row.des_unidade.label,
          value: row.des_unidade.value,
        },
      });
      handleOpenModalDerivado(true);
      handleIsEditingDerivado(true);
    },
    [handleIsEditingDerivado, handleOpenModalDerivado, resetDerivado],
  );

  const handleDelete = useCallback(
    (row: IProdutoDerivado) => {
      const rowsDetail: any[] = deleteItens(
        'produtos-derivados',
        row.uuid,
        masterDetail,
        setMasterDetail,
      );
      setRowsDerivado(rowsDetail);
    },
    [masterDetail, setMasterDetail, setRowsDerivado],
  );

  return (
    <ContainerGrid>
      <DataGrid
        style={{ minHeight: '380px' }}
        className="grid"
        pageSize={5}
        rows={rowsDerivado}
        columns={columnsDerivados}
        loading={loadingTableDerivado}
        getRowId={(row) => row.uuid}
        disableColumnFilter
        disableColumnSelector
        disableColumnMenu
        disableSelectionOnClick
        localeText={{
          noRowsLabel: 'Nenhum registro encontrado....',
          columnMenuLabel: 'Menu',
          columnMenuFilter: 'Filtrar',
          columnMenuHideColumn: 'Esconder',
          columnMenuUnsort: 'Não ordenar',
          columnMenuSortAsc: 'Ordernar ASC',
          columnMenuSortDesc: 'Ordernar DESC',
          columnMenuShowColumns: 'Mostrar columnas',
        }}
      />
    </ContainerGrid>
  );
};
